import { gql } from '@efficiently/client-core-graphql-models';

/**
 * How many Design Change history rows one scope (Project Bid) carries, read without loading the
 * cards themselves.
 *
 * Guarded server-side by `ProjectBidView` and `DesignChangeView` together. Non-null on the wire
 * (`Int!`), so the count never needs a null check.
 */
export const PROJECT_BID_DESIGN_CHANGE_ROWS_COUNTER = gql(`
	query ProjectBidDesignChangeRowsCounter($projectBidId: ID!) {
		projectBidDesignChangeRowsCounter(projectBidId: $projectBidId)
	}
`);
